export default {

  data() {
    return {
      columns: [
        {
          column: 'type',
          title: this.__('common.type'),
          custom: true
        },
        {
          column: 'activityDate',
          title: this.__('common.date'),
          sortable: true,
        },
        {
          column: 'subject',
          title: this.__('common.subject'),
          custom: true
        },
        {
          column: 'status',
          title: this.__('common.status'),
          custom: true
        },
        {
          column: 'remaining',
          title: this.__('common.due-in'),
        },
        {
          column: 'user.name',
          title: this.__('common.responsible'),
        },
      ],
    }
  }
}
